import styled from 'styled-components';

export const ValuesSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--space-l);

  padding: var(--space-xxxl);

  background: linear-gradient(
    180deg,
    rgba(255, 248, 235, 0.42) 0%,
    rgba(255, 255, 255, 0.9) 100%
  );

  border: 1px solid rgba(230, 139, 7, 0.08);
  border-radius: 20px;

  .valuesTop {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: var(--space-xs);

    max-width: 720px;
  }

  .miniLabel {
    color: var(--orange5);

    font-size: 0.78rem;
    font-weight: 900;

    text-transform: uppercase;
    letter-spacing: 0.12em;
  }

  p {
    margin: 0;

    color: var(--grey4);

    font-size: 0.96rem;
    line-height: 1.75;
    font-weight: 500;
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-l);
    gap: var(--space-m);
  }
`;

export const ValuesList = styled.div`
  display: flex;
  flex-wrap: wrap;

  gap: var(--space-s);
`;

export const ValueItem = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0.5rem 1rem;

  border-radius: 999px;

  background: rgba(255, 255, 255, 0.82);

  border: 1px solid rgba(230, 139, 7, 0.1);

  color: var(--grey5);

  font-size: 0.84rem;
  line-height: 1;
  font-weight: 700;

  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.03);
`;
